import React from "react";
import Header from "../components/Header";

import ContactButton from "../components/ContactButton";
import MenuManager from "../components/Menu/MenuManager";

import "../styles/home.scss";

const Home = () => {
    return (
        <MenuManager>
            <Header />
            <div className="main-container" id="main-container">
                <h1>
                    Gihan <br /> Graphics
                </h1>
                <svg>
                    <filter id={'fire'}>
                        <feTurbulence id={'turbulence'} baseFrequency={'0.1 0.1'} numOctaves={2} seed={3} ></feTurbulence>
                        <feDisplacementMap in={'SourceGraphic'} scale={1}></feDisplacementMap>
                    </filter>
                </svg>      
                <ContactButton />
            </div>
        </MenuManager>
    );
};
export default Home;